var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDoubleNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3315 7.69219L4.34244 2.59531C4.29557 2.53438 4.22213 2.5 4.14557 2.5H2.93775C2.83307 2.5 2.77525 2.62031 2.83932 2.70156L6.98619 8L2.83932 13.2984C2.82489 13.3169 2.81594 13.339 2.81348 13.3622C2.81103 13.3855 2.81518 13.409 2.82544 13.43C2.83571 13.4511 2.85169 13.4688 2.87155 13.4811C2.89141 13.4935 2.91435 13.5001 2.93775 13.5H4.14557C4.22213 13.5 4.29557 13.4641 4.34244 13.4047L8.3315 8.30937C8.47369 8.12656 8.47369 7.87344 8.3315 7.69219ZM13.0815 7.69219L9.09244 2.59531C9.04557 2.53438 8.97213 2.5 8.89557 2.5H7.68775C7.58307 2.5 7.52525 2.62031 7.58932 2.70156L11.7362 8L7.58932 13.2984C7.57489 13.3169 7.56594 13.339 7.56348 13.3622C7.56103 13.3855 7.56518 13.409 7.57544 13.43C7.58571 13.4511 7.60169 13.4688 7.62155 13.4811C7.64141 13.4935 7.66435 13.5001 7.68775 13.5H8.89557C8.97213 13.5 9.04557 13.4641 9.09244 13.4047L13.0815 8.30937C13.2237 8.12656 13.2237 7.87344 13.0815 7.69219Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoubleNextIcon);
export default __webpack_public_path__ + "static/media/arrowDoubleNextIcon.4b11952908d64d66920e5f19e7bbf50f.svg";
export { ForwardRef as ReactComponent };